import type { Framework7Parameters } from 'framework7/types';
import { reportThemeAccentFallback } from '@/lib/observability/faro-client';

export const fallbackAccent = '#f94e2b';
const hexColor = /^#(?:[\da-f]{3}){1,2}$/i;

// Framework7 generates the whole Material 3 palette (surfaces, containers,
// outlines) at init from `colors.primary` and injects it as a runtime `:root`
// stylesheet — which outranks the static `--f7-md-*` mappings in
// restaurant-theme.css. Left at F7's default blue, that painted Android's bars
// and the active tab pill in a lavender that belongs to no part of our brand,
// while iOS (which reads far fewer of those tokens) stayed white/coral. Feed it
// the brand accent — read from the theme layer, which stays the single source of
// truth — so both platforms derive from the same colour. Read lazily (at render,
// not module eval) because the theme stylesheet is imported after this module.
export function brandColors(): Framework7Parameters['colors'] {
  const accent = getComputedStyle(document.documentElement).getPropertyValue('--rt-accent').trim();
  if (hexColor.test(accent)) return { primary: accent };
  reportThemeAccentFallback(accent);
  return { primary: fallbackAccent };
}
